import { gql } from "@apollo/client";

export const setPasswordQuery = gql`
mutation setPassword($username: String!, $password: String!) {
  setPassword(username: $username, password: $password) {
    success
  }
}
`;
